import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import { IMPRESSION_NAMES } from 'garaje/utils/enums';
let PhoneNumberCollection = (_class = class PhoneNumberCollection extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "workplaceMetrics", _descriptor2, this);
    _initializerDefineProperty(this, "impressions", _descriptor3, this);
    _initializerDefineProperty(this, "state", _descriptor4, this);
    _initializerDefineProperty(this, "dismissed", _descriptor5, this);
    _defineProperty(this, "isPreviouslyDismissed", _buildTask(() => ({
      context: this,
      generator: function* () {
        const closedImpressions = yield this.impressions.getImpressions.perform(IMPRESSION_NAMES.EMERGENCY_NOTIFICATIONS.PHONE_NUMBER_BANNER_DISMISSED);
        this.dismissed = isPresent(closedImpressions);
      }
    }), {
      drop: true
    }, "isPreviouslyDismissed", null));
    void this.isPreviouslyDismissed.perform();
  }
  get isVisible() {
    return !!this.args.emergencyNotificationConfiguration?.passivePhoneNumberCollectionEnabledAt && !this.state.currentCompany?.directorySyncProvider && !!this.state.workplaceSubscription?.canAccessEmergencyNotifications && !this.args.userHasPhoneNumber;
  }
  async trackRedirect() {
    this.workplaceMetrics.trackEvent('EMERGENCY_NOTIFICATIONS_PHONE_NUMBER_BANNER_CTA_CLICKED');
    await this.impressions.postImpression.perform(IMPRESSION_NAMES.EMERGENCY_NOTIFICATIONS.PHONE_NUMBER_BANNER_CLICKED);
  }
  async dismiss() {
    this.dismissed = true;
    await this.impressions.postImpression.perform(IMPRESSION_NAMES.EMERGENCY_NOTIFICATIONS.PHONE_NUMBER_BANNER_DISMISSED);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "workplaceMetrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "impressions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "state", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "dismissed", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "trackRedirect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "trackRedirect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dismiss", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dismiss"), _class.prototype)), _class);
export { PhoneNumberCollection as default };